import { useState } from 'react';
import { SpinnerContext } from '@contexts';


interface SpinnerProviderProps {
    children: React.ReactNode
}

function SpinnerProvider({ children }: SpinnerProviderProps) {
    const [show, setSpinnerShow] = useState(false);
    const value = { show, setSpinnerShow };
    return <SpinnerContext.Provider value={value}>{children}</SpinnerContext.Provider>;
}

export default SpinnerProvider;
